/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsUserAlphabet,
    SharedserviceMelcoModelsUserAlphabetFromJSON,
    SharedserviceMelcoModelsUserAlphabetFromJSONTyped,
    SharedserviceMelcoModelsUserAlphabetToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsDesignLetteringElement
 */
export interface SharedserviceMelcoModelsDesignLetteringElement {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    alphabet_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    angle?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    width_factor?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    slant_angle?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    tracking?: number;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    rotation_direction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    layout_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    justification?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    radius?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    horizontal_stitch_order?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    vertical_stitch_order?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    connection_type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    continuous_underlay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    default_text?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    text_max_length?: number;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    default_alphabet_id?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsUserAlphabet>}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    alphabet_list?: Array<SharedserviceMelcoModelsUserAlphabet> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignLetteringElement
     */
    renderer_index?: number;
}

export function SharedserviceMelcoModelsDesignLetteringElementFromJSON(json: any): SharedserviceMelcoModelsDesignLetteringElement {
    return SharedserviceMelcoModelsDesignLetteringElementFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsDesignLetteringElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsDesignLetteringElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
        'alphabet_name': !exists(json, 'alphabet_name') ? undefined : json['alphabet_name'],
        'angle': !exists(json, 'angle') ? undefined : json['angle'],
        'width_factor': !exists(json, 'width_factor') ? undefined : json['width_factor'],
        'slant_angle': !exists(json, 'slant_angle') ? undefined : json['slant_angle'],
        'tracking': !exists(json, 'tracking') ? undefined : json['tracking'],
        'rotation_direction': !exists(json, 'rotation_direction') ? undefined : json['rotation_direction'],
        'layout_type': !exists(json, 'layout_type') ? undefined : json['layout_type'],
        'justification': !exists(json, 'justification') ? undefined : json['justification'],
        'radius': !exists(json, 'radius') ? undefined : json['radius'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'horizontal_stitch_order': !exists(json, 'horizontal_stitch_order') ? undefined : json['horizontal_stitch_order'],
        'vertical_stitch_order': !exists(json, 'vertical_stitch_order') ? undefined : json['vertical_stitch_order'],
        'connection_type': !exists(json, 'connection_type') ? undefined : json['connection_type'],
        'continuous_underlay': !exists(json, 'continuous_underlay') ? undefined : json['continuous_underlay'],
        'default_text': !exists(json, 'default_text') ? undefined : json['default_text'],
        'text_max_length': !exists(json, 'text_max_length') ? undefined : json['text_max_length'],
        'default_alphabet_id': !exists(json, 'default_alphabet_id') ? undefined : json['default_alphabet_id'],
        'alphabet_list': !exists(json, 'alphabet_list') ? undefined : (json['alphabet_list'] === null ? null : (json['alphabet_list'] as Array<any>).map(SharedserviceMelcoModelsUserAlphabetFromJSON)),
        'renderer_index': !exists(json, 'renderer_index') ? undefined : json['renderer_index'],
    };
}

export function SharedserviceMelcoModelsDesignLetteringElementToJSON(value?: SharedserviceMelcoModelsDesignLetteringElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'alphabet_name': value.alphabet_name,
        'angle': value.angle,
        'width_factor': value.width_factor,
        'slant_angle': value.slant_angle,
        'tracking': value.tracking,
        'rotation_direction': value.rotation_direction,
        'layout_type': value.layout_type,
        'justification': value.justification,
        'radius': value.radius,
        'height': value.height,
        'horizontal_stitch_order': value.horizontal_stitch_order,
        'vertical_stitch_order': value.vertical_stitch_order,
        'connection_type': value.connection_type,
        'continuous_underlay': value.continuous_underlay,
        'default_text': value.default_text,
        'text_max_length': value.text_max_length,
        'default_alphabet_id': value.default_alphabet_id,
        'alphabet_list': value.alphabet_list === undefined ? undefined : (value.alphabet_list === null ? null : (value.alphabet_list as Array<any>).map(SharedserviceMelcoModelsUserAlphabetToJSON)),
        'renderer_index': value.renderer_index,
    };
}


